import React, {forwardRef, useState} from 'react';
import BaseSimpleItemBrowser from "../BaseSimplePage/BaseSimpleItemBrowser";
import ArtistSuggestionsItemBrowserHeader from "./ArtistSuggestionsItemBrowserHeader";
import {allArtistRoles} from "../../data/Enums";

const ArtistSuggestionsItemBrowser = forwardRef(({
                                             ...restProps
                                         }, ref) => {

    const [mainRoleId, setMainRoleId] = useState(0);
    const [filterExtraParams, setFilterExtraParams] = useState({});

    function renderHeader(headerProps) {
        return <ArtistSuggestionsItemBrowserHeader
            {...headerProps}
            mainRoleId={mainRoleId}
            setMainRoleId={handleMainRoleIdChange}
        />
    }

    function handleMainRoleIdChange(value) {
        const newFilterExtraParams = {...filterExtraParams};
        if (value === 0)
            delete newFilterExtraParams.role;
        else
            newFilterExtraParams.role = value;

        setMainRoleId(value);
        setFilterExtraParams(newFilterExtraParams);
        ref.current.onFilterEdit(true);
    }

    return (
        <BaseSimpleItemBrowser
            {...restProps}
            ref={ref}
            getItemTitleFunc={getItemTitle}
            getItemSubtitleFunc={getItemSubTitle}
            renderHeaderFunc={renderHeader}
            filterExtraParams={filterExtraParams}
        />
    );
});

// TODO? share?
function getItemTitle(item) {
    return item.fio ?? "?";
}

function getItemSubTitle(item) {
    return allArtistRoles.find(x => x.id === item.role)?.name ?? "?";
}

export default ArtistSuggestionsItemBrowser;